import { userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
};

export const reducer = createReducer(initialState, {
    [userActions.loadSessionRequest]: (state, action) => {
        state.loading = true;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        state.loading = false;
    },
    [userActions.loadSessionFailure]: (state, action) => {
        state.loading = false;
    },
})